// extracted by mini-css-extract-plugin
export default {"saveInfoBanner":"SaveInfoBanner_saveInfoBanner__U801C","slideDown":"SaveInfoBanner_slideDown__vLSpc"};